import {
  AfterViewInit,
  Component,
  ElementRef, EventEmitter,
  Inject,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {CommonModule, DOCUMENT} from '@angular/common';
import {WP_REST_API_Menu_item} from "../../../models/Wordpress/WP_REST_API_Menu_item";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'head-menu-item',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './head-menu-item.component.html',
  styleUrl: './head-menu-item.component.scss',
  host: {ngSkipHydration: 'true'}
})
export class HeadMenuItemComponent implements AfterViewInit{
  @Input() navigationItem : WP_REST_API_Menu_item;
  @Output() navigationItemChange = new EventEmitter<WP_REST_API_Menu_item>;
  @ViewChild('NavigationItems') navigationItemsRef: ElementRef;
  @Input() hasOverlay = false;
  @Input() scrolled = false;
  constructor(@Inject(DOCUMENT) private doc: Document) {
  }

  ngAfterViewInit(){
    this.setPaddingTop();
  }

  setPaddingTop(){
    if(typeof document !== "undefined"){
      const headerBar = document.getElementById("HeaderNavbar");
      if(headerBar){
        this.navigationItemsRef.nativeElement.style.height = `${window.innerHeight - headerBar.clientHeight}px`;
      }
    }
  }

  onNavItemClick(){
    this.navigationItem.show = !this.navigationItem.show;
    if(this.navigationItem.show){
      this.setBodyUnscrollable();
      this.setPaddingTop();
    } else {
      this.removeBodyUnscrollable();
    }
    this.navigationItemChange.emit(this.navigationItem);
  }

  onBackItemClick(navItem:WP_REST_API_Menu_item){
    navItem.show = false;
  }

  onSubNavItemClick(navItem:WP_REST_API_Menu_item,menu:WP_REST_API_Menu_item[]){
    const recursiveHide = (menu:WP_REST_API_Menu_item[])=>{
      if(menu){
        menu.forEach((i)=>{
          if(i.ID != navItem.ID){
            i.show = false;
          }
          recursiveHide(i.children);
        })
      }
    }
    recursiveHide(menu);
    navItem.show = true;
  }

  setBodyUnscrollable(){
    this.doc.body.classList.add("unscrollable");
  }
  removeBodyUnscrollable(){
    this.doc.body.classList.remove("unscrollable");
  }
}
